import * as React from 'react';
import * as store from './store';

export const ModalContainer = () => {
  const [modals, setModals] = React.useState(store.getModals());

  React.useEffect(
    () => store.subscribe((nextModals) => setModals(nextModals)),
    []
  );

  const elements = modals.map((modal) => (
    <React.Fragment key={modal.id}>{modal.render(modal)}</React.Fragment>
  ));

  return (
    <>
      {elements}
    </>
  );
};

let nextNamespaceId = 1;

export const usePageModals = () => {
  const namespace = React.useMemo<string>(() => `${++nextNamespaceId}`, []);
  const open: store.IModalOpen = (render, options) => {
    return store.open(render, { ...options, namespace });
  };

  React.useEffect(
    () => store.closeByNamespace.bind(null, namespace),
    [namespace]
  );

  return { ...store, open };
};



// WEBPACK FOOTER //
// ./src/shared/Modal/index.tsx